/**
 * Chess Piece Component (Inline Styles)
 * Default export - uses inline styles with text-shadow
 */
import type { PieceProps } from "../../types";
import { PieceBase } from "./PieceBase";

export function Piece({ piece }: PieceProps) {
  const isWhite = piece.color === "WHITE";
  const style: React.CSSProperties = {
    fontSize: "48px",
    lineHeight: 1,
    userSelect: "none",
    cursor: "pointer",
    color: isWhite
      ? "var(--cn-chess-piece-white)"
      : "var(--cn-chess-piece-black)",
    textShadow: isWhite
      ? "0 0 1px var(--cn-chess-piece-white-stroke), 0 0 2px var(--cn-chess-piece-white-stroke), 1px 1px 2px var(--cn-chess-piece-white-stroke)"
      : "none",
    filter: isWhite
      ? "drop-shadow(0 1px 1px var(--cn-chess-piece-white-stroke))"
      : "none",
  };

  return <PieceBase piece={piece} style={style} />;
}
